import { Component, OnInit } from '@angular/core';
import {VideoService} from '../../shared/services/video.service';
import {ExternalpageService, externalpageTypes} from '../../shared/services/externalpage.service';
import {ExternalpageOverview} from '../../class/externalpage-overview';
import {DomainService} from '../../shared/services/domain.service';

@Component({
    selector: 'app-page-videos',
    templateUrl: './page-videos.component.html',
    styleUrls: ['./page-videos.component.scss'],
    standalone: false
})
export class PageVideosComponent extends ExternalpageOverview implements OnInit {

  public nodes :any = [];

  public view = {
    pageType: externalpageTypes.Video,
    queryParams: {
      pageSize: 9,
      pageNumber: 1,
      totalItems: 0
    },
    data: <any[]> [],
  }

  /**
   * Constructor
   *
   * @param externalpageService
   * @param videoService
   */
  constructor(
    public externalpageService: ExternalpageService,
    protected domain: DomainService,
    public videoService: VideoService
  ) {
      super(externalpageService, domain);
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.loadData();

  }

}
